function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  rx: 2,
  fill: "#F3F3F3"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3333 2H5.66667C4.69421 2 3.76158 2.38631 3.07394 3.07394C2.38631 3.76158 2 4.69421 2 5.66667V10.3333C2 11.3058 2.38631 12.2384 3.07394 12.9261C3.76158 13.6137 4.69421 14 5.66667 14H10.3333C11.3058 14 12.2384 13.6137 12.9261 12.9261C13.6137 12.2384 14 11.3058 14 10.3333V5.66667C14 4.69421 13.6137 3.76158 12.9261 3.07394C12.2384 2.38631 11.3058 2 10.3333 2ZM13 10.3333C12.9992 11.0403 12.718 11.7181 12.2181 12.2181C11.7181 12.718 11.0403 12.9992 10.3333 13H5.66667C4.95967 12.9992 4.28186 12.718 3.78193 12.2181C3.28201 11.7181 3.0008 11.0403 3 10.3333V5.66667C3.00079 4.95967 3.282 4.28185 3.78193 3.78193C4.28185 3.282 4.95967 3.00079 5.66667 3H10.3333C11.0403 3.00079 11.7182 3.282 12.2181 3.78193C12.718 4.28185 12.9992 4.95967 13 5.66667V10.3333Z",
  fill: "#292929"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M8 5C7.40666 5 6.82664 5.17595 6.33329 5.50559C5.83994 5.83524 5.45543 6.30377 5.22836 6.85195C5.0013 7.40013 4.94189 8.00333 5.05765 8.58527C5.1734 9.16721 5.45912 9.70176 5.87868 10.1213C6.29824 10.5409 6.83279 10.8266 7.41473 10.9424C7.99667 11.0581 8.59987 10.9987 9.14805 10.7716C9.69623 10.5446 10.1648 10.1601 10.4944 9.66671C10.8241 9.17336 11 8.59334 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79565 5 8 5ZM8 10C7.60444 10 7.21776 9.8827 6.88886 9.66294C6.55996 9.44318 6.30362 9.13082 6.15224 8.76537C6.00087 8.39991 5.96126 7.99778 6.03843 7.60982C6.1156 7.22186 6.30608 6.86549 6.58579 6.58579C6.86549 6.30608 7.22186 6.1156 7.60982 6.03843C7.99778 5.96126 8.39992 6.00087 8.76537 6.15224C9.13082 6.30362 9.44318 6.55996 9.66294 6.88886C9.8827 7.21776 10 7.60444 10 8C9.9994 8.53025 9.78849 9.03861 9.41355 9.41355C9.03861 9.78849 8.53025 9.9994 8 10Z",
  fill: "#292929"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1333 5.53328C11.5015 5.53328 11.8 5.23481 11.8 4.86662C11.8 4.49843 11.5015 4.19995 11.1333 4.19995C10.7652 4.19995 10.4667 4.49843 10.4667 4.86662C10.4667 5.23481 10.7652 5.53328 11.1333 5.53328Z",
  fill: "#292929"
});

var SvgInstagram = function SvgInstagram(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Instagram.01995cb3.svg";
export { ForwardRef as ReactComponent };